<template>
  <Btn
    :variant="
      content.launchData?.completedAt ? BtnVariant.OUTLINED : BtnVariant.FILLED
    "
    :color="BtnColor.SUCCESS"
    :size="BtnSize.LG"
    :disabled="content.launchData?.completedAt"
    class="whitespace-nowrap w-full md:w-fit"
    @click="handleCompleteContent"
  >
    <template v-if="content.launchData?.completedAt">
      {{ $t('launch-content-navigation-banner.completed') }}
      <icon :icon="CheckSvg" :size="IconSize.SM" class="ml-2" />
    </template>
    <span v-else>
      {{ $t('launch-content-navigation-banner.mark-as-completed') }}
    </span>
  </Btn>
</template>
<script setup lang="ts">
import { Btn, BtnColor, BtnSize, BtnVariant } from '~/components/btn';
import CheckSvg from 'assets/icons/check.svg';
import { Icon, IconSize } from '~/components/icon';
import { ContentDto } from '~/api/contents';
import { useLoader } from '~/composables/use-loader';
import { createContentLaunchMetric, LaunchMetricType } from '~/api/metrics';

type Props = {
  content: ContentDto;
  hubSlug: string;
};

const props = defineProps<Props>();

const emit = defineEmits<{
  complete: [];
}>();

const handleCompleteContent = async () => {
  await useLoader({
    async action() {
      await createContentLaunchMetric(
        props.hubSlug,
        props.content.slug,
        LaunchMetricType.COMPLETED,
      );
      emit('complete');
    },
  });
};
</script>
